async function select() {
  let selectHeader = document.querySelectorAll('.select__header');
  let selectItem = document.querySelectorAll('.select__item');
  let selectPriceFrom = document.querySelector("#pricefrom");
  let selectPriceTo = document.querySelector("#priceto");
  let ranges = document.querySelectorAll(".select-price-range")
  let catalogFilter = document.querySelector(".catalog-filter");
  let allParametrsBtn = document.querySelector(".catalog-all-param");
  let secondFilterSection = document.querySelector(".catalog-filter-form-bottom-section");
  let parametrsBtn = document.querySelector(".catalog-filter-mobile");
  let closeCatalogFilter = document.querySelector(".mobile-modal-close");
  let showOfferBtn = document.querySelector(".show-offer");
  let catalogMobileName = document.querySelector(".catalog-mobile-modal-name");



  if (selectHeader) {
    selectHeader.forEach(item => {
      item?.addEventListener('click', selectToggle)
    });
  }
  
  document.addEventListener("click", (event) => {
    if(!event.target.closest('.select')) {
     selectHeader.forEach(item => {
   item.parentElement.classList.remove('is-active')})
    }
   })
 

  selectItem.forEach(item => {
    item?.addEventListener('click', selectChoose)
  });

  selectPriceFrom?.addEventListener("input", editInputSize)
  selectPriceTo?.addEventListener("input", editInputSize)
  selectPriceFrom?.addEventListener("change", editInputSize)
  selectPriceTo?.addEventListener("change", editInputSize)


  ranges.forEach(range => {
    range?.addEventListener("input", (event) => {
      let input = range.parentElement.querySelector("input[type='text']")
      const tempInput = event.target.value;
      input.value = tempInput;

    })
    range?.addEventListener("change", (event) => {
      let input = range.parentElement.querySelector("input[type='text']")
      let CustomEvent = new Event("change");
      input.dispatchEvent(CustomEvent);
    })
  })

  allParametrsBtn?.addEventListener("click", (event) => {
    secondFilterSection.classList.toggle("openSecondSection")
    allParametrsBtn.querySelector(".catalog-all-name").classList.toggle("dnone");
    allParametrsBtn.querySelector(".catalog-hidden-name").classList.toggle("dnone");
  });


  var previosWindowWidth = window.innerWidth;
  // MOBILE MODAL CATALOGG
  window.addEventListener("resize", (event) => {
    if (catalogFilter) {
      if (window.innerWidth < 768) {
        if(previosWindowWidth && previosWindowWidth < 768) {
          previosWindowWidth = window.innerWidth;
          return;
        }
        previosWindowWidth = window.innerWidth;
        catalogFilter.classList.add("dnone")
      }
      else {
        catalogFilter.classList.remove("dnone")
        document.body.classList.remove("noscroll");
      }
    }


  });

  if (catalogFilter) {
    if (window.innerWidth < 768) {
      catalogFilter.classList.add("dnone")
    }
    else {
      catalogFilter.classList.remove("dnone")
      document.body.classList.remove("noscroll");
    }

    parametrsBtn.addEventListener("click", (event) => {
      catalogFilter.classList.remove("dnone");
      catalogFilter.classList.add("catalog-mobile-open")
      document.body.classList.add("noscroll");
    });
  }




  // closeCatalogFilter.addEventListener("click", closeMobileCatalog);
  showOfferBtn?.addEventListener("click", closeMobileCatalog);
  catalogMobileName?.addEventListener("click", closeMobileCatalog)


  function closeMobileCatalog() {
    catalogFilter.classList.add("dnone");
    catalogFilter.classList.remove("catalog-mobile-open")
    document.body.classList.remove("noscroll");
  }

  function selectToggle() {
    selectHeader.forEach(item => {
      if ((window.innerWidth < 768) && (this.closest(".multi-select")) && (item == this)) {
        let box = item.parentElement.querySelector(".select-mobile-sublist-box")
        let closeBox = item.parentElement.querySelector(".select-mobile-sublist-box").querySelector(".default-select-name");
        let acceptBtn = item.parentElement.querySelector(".select-mobile-sublist-box").querySelector(".select-mobile-sublist-cta");
        box.classList.add("catalog-mobile-sublist-open")

        closeBox.addEventListener('click', () => {
          box.classList.remove("catalog-mobile-sublist-open")
          item.parentElement.classList.remove('is-active')
        })

        acceptBtn.addEventListener('click', () => {
          box.classList.remove("catalog-mobile-sublist-open")
          item.parentElement.classList.remove('is-active')
        })

      }

      if (item == this) item.parentElement.classList.toggle('is-active')

      else item.parentElement.classList.remove('is-active');
    })
  }

  function editInputSize(event) {
    const input = event.target
    
    if(event.type == 'change') {
      let minVal =  +input.getAttribute('min')
      let maxVal =  +input.getAttribute('max')
      let value  = +input.value
      if(value < minVal) {
        input.value = minVal
      } else if(value > maxVal){
        input.value = maxVal
      }
      
    }
    let inputValueSize = input.value.length;
    input.style.width = inputValueSize * 10 + 'px';
    input.style.maxWidth = 80 + 'px';

    var range = input.closest(".select").querySelector('input[type="range"]')
    if(range) {
      range.value = input.value
    }
    
  }

  function selectChoose() {
    let text = this.innerText,
      select = this.closest('.select'),
      currentText = select.querySelector('.select__current'),
      defaultNameValue = select.querySelector(".select__default")
      valueToInput = this.getAttribute('value')
      ;

    // select.classList.remove('is-active');

    if (this.closest(".single-select")) {
      this.closest(".single-select").querySelector('input').value = valueToInput ? valueToInput : text
      this.closest(".single-select").querySelector('input').dispatchEvent(new Event("change"));
      currentText.innerText = text.trim();

      if ((this.closest(".select-milleagefrom")) || (this.closest(".select-milleageto")) || (this.closest(".select-reservefrom")) || (this.closest(".select-reserveto"))) {
        currentText.innerText += " км"
      }
      if ((this.closest(".select-capacityfrom")) || (this.closest(".select-capacityto"))) {
        currentText.innerText += " литра"
      }
    }


    else if (this.closest(".multi-select")) {

      let checkboxs = select.querySelectorAll(('.checkbox'))
      let selectCount = select.querySelector('.select-count');
      let selectCountValue = 0
      let textValue = [];

      checkboxs.forEach(item => {
        if (item.checked && !item.disabled) {
          if(select.classList.contains('useText')) {
            textValue.push(select.querySelector('label[for="'+ item.id +'"]').innerText);
          } else {
            textValue.push(item.id);
          }
          selectCountValue++
          selectCount.innerText = selectCountValue

          item.parentElement.querySelector("label").classList.add("selectedBgc");

        }
        else {
          item.parentElement.querySelector("label").classList.remove("selectedBgc");
        }

        currentText.innerText = textValue.join(', ');
      }

      );

      if (currentText.innerText.length !== 0) {
        defaultNameValue.classList.add("dnone");

      }
      else {
        defaultNameValue.classList.remove("dnone");
        selectCount.innerText = null
      }


    }
  }

};

select();

document?.addEventListener('loadedNewImages', renderDisplayCarGallery);
// Дожидаемся полной загрузки DOM
// if(window.useDelayImages == true) {
//   document?.addEventListener("imagesReady", renderDisplayCarGallery);
// } else {
  document?.addEventListener("DOMContentLoaded", renderDisplayCarGallery);
// }

async function renderDisplayCarGallery() {

  const allCards = document.querySelectorAll(".offer-card")

  allCards.forEach(item => renderPagynations(item))

  function renderPagynations(item) {
    if (innerWidth >= 768) {
      const imgContainer = item.querySelector('.news__card-img-box');
      const imgElement = imgContainer.querySelector('.offer__card-img');
      const paginationBox = item.querySelector('.offer-card-paginations');

      let isHasPagination = paginationBox.querySelector('.offer-card-paginations-item');
      const dataImages = JSON.parse(imgElement.getAttribute('data-images'));

      if(isHasPagination === null) {      
        for (let i = 0; i < dataImages.length; i++) {
          if (i === 0) {
            paginationBox.insertAdjacentHTML('beforeend', `
          <div class="offer-card-paginations-item offer-card-paginations-item--active" data-number="${i}"></div>
        `
            )
          }
          else {
            paginationBox.insertAdjacentHTML('beforeend', `
        <div class="offer-card-paginations-item" data-number="${i}"></div>
      `
            )
          }

        }
      }

      // Добавляем обработчик для mousemove
      imgContainer?.addEventListener('mousemove', (e) => {
        const { offsetX: mouseX, target } = e;
        const { offsetWidth: width } = target;
        const part = mouseX / width; // Процентная позиция курсора относительно ширины элемента
        const imageIndex = Math.floor(part * dataImages.length); // Вычисляем индекс картинки
        let paginationsItems = paginationBox.querySelectorAll(".offer-card-paginations-item")

        // Обновляем исходное изображение, если индекс в пределах массива
        if (imageIndex >= 0 && imageIndex < dataImages.length) {
          imgElement.src = dataImages[imageIndex];


          paginationsItems.forEach(item => {

            if (imageIndex == item.getAttribute('data-number')) {
              item.classList.add("offer-card-paginations-item--active")
            }

            else item.classList.remove("offer-card-paginations-item--active")
          })


        }
      });

      imgContainer.addEventListener('mouseout', (e) => {
        const { offsetX: mouseX, target } = e;
        const { offsetWidth: width } = target;
        const part = mouseX / width; // Процентная позиция курсора относительно ширины элемента
        const imageIndex = Math.floor(part * dataImages.length); // Вычисляем индекс картинки
        let paginationsItems = paginationBox.querySelectorAll(".offer-card-paginations-item")

        imgElement.src = dataImages[0];
        paginationsItems.forEach(item => {

          if (item.getAttribute('data-number') == 0) {
            item.classList.add("offer-card-paginations-item--active")
          }

          else item.classList.remove("offer-card-paginations-item--active")
        })
      })
    }
  }
}

if(!window.disableFilter || window.disableFilter === false) {
  document.querySelectorAll('.catalog-another-clear')?.forEach(item => {
    item.addEventListener('click', clearFilter)
  })
  function clearFilter(e) {
    document.querySelectorAll('.select__item input[type="checkbox"]:checked')?.forEach(item => {
      item.checked = false
    })
    document.querySelectorAll('.select__current, .select-count')?.forEach(item => {
      item.innerHTML = ''
    })
    document.querySelectorAll('.select__default.default-select-name.dnone')?.forEach(item => {
      item.classList.remove('dnone')
    })
    document.querySelectorAll('.single-select input')?.forEach(item => {
      let defaultVal = item.getAttribute('default')
      item.value = defaultVal ? defaultVal : '';
    })
    document.querySelectorAll('.single-select .select__current')?.forEach(item => {
      let defaultVal = item.getAttribute('default')
      item.innerHTML = defaultVal ? defaultVal : '';
    })

    document.querySelector('.select__item input[type="checkbox"]').dispatchEvent(new Event("change"))
    updateDisplaySelectedVals()
  }

  document.querySelectorAll('.select__item input[type="checkbox"]')?.forEach(item => {
    item.addEventListener('click', updateDisplaySelectedVals)
  })
  function updateDisplaySelectedVals(e) {
    const tagBox = document.querySelector('.selected-tag-box');
    tagBox.innerHTML = '';
    document.querySelectorAll('.select__item input[type="checkbox"]:checked')?.forEach(item => {
      let displayText = item.id;
      if(item.type == 'checkbox') {
        let label = document.querySelector('label[for="'+item.id+'"]')
        if(label) {
          displayText = label.innerText
        }
      }
      const newP = document.createElement("p");
      newP.classList.add('selected-tag-name');
      newP.setAttribute('for', item.id);
      newP.innerHTML = displayText;
      newP.addEventListener('click', unselectVal)
      tagBox.append(newP)
    })
  }
  function unselectVal(e) {
    let element = document.getElementById(this.getAttribute('for'));
    element.checked = false;
    element.parentElement.dispatchEvent(new Event("click"))
    element.dispatchEvent(new Event("change"))
    this.remove()
  }
}
const orderByFilter = document.getElementById('orderBy')
document.querySelector('#order-by-select')?.addEventListener('change', updateOrderByInFilter)
function updateOrderByInFilter(e) {
  orderByFilter.value = this.value
  orderByFilter.dispatchEvent(new Event("change"))
}